import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
  width: 100%;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;

    h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 500;
    }

    > div {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 0.5rem;
    }
  }
`;
